
define('text!templates/pages/wishlist/offers/filter-day.ejs',[],function () { return '<div>\n    <%- name %>\n    <% if (count) { %>\n    <span class="badge badge-important"><%= count %></span>\n    <% } %>\n</div>';});

